/* import __COLOCATED_TEMPLATE__ from './toolbar-popup-menu-options-heading.hbs'; */
import Component from "@ember/component";
export default Component.extend({});